/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState,  useCallback } from 'react'
import { UserContext } from 'stores/UserStore'
import inspectionReport from 'api/inspectionReport'

export const InspectionReportContext = React.createContext({})

export const InspectionReportProvider = ({ children }) => {

  const { idToken, currentUser, registryLog } = useContext(UserContext)
  const [isLoading, setLoading] = useState(false)
  const [tableData, setTableData] = useState([])
  const [totalData, setTotalData] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [page, setPage] = useState(0)
  const [filters, setFilters] = useState({})
  const [reportToApproval, setReportToApproval] = useState(null)
  const [reportToWorkflow, setReportToWorkflow] = useState(null)
  const [showFinalized, setShowFinalized] = useState(false)
  const [approvalType, setApprovalType] = useState(null)

  const [sotList, setSotList] = useState([])
  const [sotItemList, setSotItemList] = useState([])
  const [reportIdList, setRepostIdList] = useState([])
  const [reportVersionList, setReportVersionList] = useState([])
  const [inspectionDateList, setInspectionDateList] = useState([])
  const [reportDateList, setReportDateList] = useState([])
  
  const [processStatusList, setProcessStatusList] = useState([])  
  const [workflowStatusList, setWorkflowStatusList] = useState([])  
  const [nextWorkflowStatusList, setNextWorkflowStatusList] = useState([])  


  const getInspectionReportData = useCallback((filters, showFinalized, page) => new Promise((resolve, reject) => {
    setLoading(true)
    setTableData([])
    setReportToApproval(null)

    inspectionReport.management(idToken, { filters: filters, showFinalized, page }).then(data => {
      if (typeof data === 'string') { data = JSON.parse(data).body } else if (data.body) { data = data.body }
      setTableData(data.tableData)
      setTotalData(data.total)
      setTotalPages(data.totalPage)
      setPage(data.actualPage)
      setLoading(false)
      resolve()
    }).catch(e => {
      reject(e)
    })

  }), [idToken])


  const getSotList = useCallback(() => new Promise((resolve, reject) => {
    setSotList([]);
    inspectionReport.management(idToken, { list: 'sot' }).then(data => {
      setSotList(data.body.listData);
      resolve()
    }).catch(e => {
      reject(e)
    })
  }), [idToken])

  const getSotItemList = useCallback(() => new Promise((resolve, reject) => {
    setSotItemList([]);
    inspectionReport.management(idToken, { list: 'sot_item' }).then(data => {
      setSotItemList(data.body.listData);
      resolve()
    }).catch(e => {
      reject(e)
    })
  }), [idToken])

  const getRepostIdList = useCallback(() => new Promise((resolve, reject) => {
    setRepostIdList([]);
    inspectionReport.management(idToken, { list: 'report_id' }).then(data => {
      setRepostIdList(data.body.listData);
      resolve()
    }).catch(e => {
      reject(e)
    })
  }), [idToken])

  const getReportVersionList = useCallback(() => new Promise((resolve, reject) => {
    setReportVersionList([]);
    inspectionReport.management(idToken, { list: 'report_version' }).then(data => {
      setReportVersionList(data.body.listData);
      resolve()
    }).catch(e => {
      reject(e)
    })
  }), [idToken])

  const getInspectionDateList = useCallback(() => new Promise((resolve, reject) => {
    setInspectionDateList([]);
    inspectionReport.management(idToken, { list: 'inspection_date' }).then(data => {
      setInspectionDateList(data.body.listData);
      resolve()
    }).catch(e => {
      reject(e)
    })
  }), [idToken])

  const getReportDateList = useCallback(() => new Promise((resolve, reject) => {
    setReportDateList([]);
    inspectionReport.management(idToken, { list: 'report_date' }).then(data => {
      setReportDateList(data.body.listData);
      resolve()
    }).catch(e => {
      reject(e)
    })
  }), [idToken])


  const getProcessStatusList = useCallback(() => new Promise((resolve, reject) => {
    setProcessStatusList([]);
    inspectionReport.management(idToken, { list: 'process_status' }).then(data => {
      setProcessStatusList(data.body.listData);
      resolve()
    }).catch(e => {
      reject(e)
    })
  }), [idToken])


  const getWorkflowStatusList = useCallback(() => new Promise((resolve, reject) => {
    setWorkflowStatusList([]);
    inspectionReport.management(idToken, { list: 'workflow_status' }).then(data => {
      setWorkflowStatusList(data.body.listData);
      resolve()
    }).catch(e => {
      reject(e)
    })
  }), [idToken])

  const getNextWorkflowStatusList = useCallback(() => new Promise((resolve, reject) => {
    setNextWorkflowStatusList([]);
    inspectionReport.management(idToken, { list: 'next_workflow_status' }).then(data => {
      setNextWorkflowStatusList(data.body.listData);
      resolve()
    }).catch(e => {
      reject(e)
    })
  }), [idToken])


  const getInspectionReportApprovalData = () => new Promise((resolve, reject) => {
    setLoading(true)
    inspectionReport.management(idToken, { get: reportToApproval }).then(data => {
      data = data.body ? data.body : data
      // console.debug(data)
      setReportToApproval(data.report)
      setLoading(false)
      resolve()
    }).catch(e => {
      reject(e)
    })
  })

  const internalApproveReport = (comment, approvedBy) => new Promise((resolve, reject) => {
    setLoading(true)

    const status = 'customer-internal-approved'

    const report = {
      report_id: reportToApproval.report_id,
      status: status,
      user_id: currentUser.id,
      user_name: approvedBy,
      user_comment: comment
    }

    inspectionReport.approval(idToken, report).then(data => {
      data = data.body ? data.body : data
      // console.debug(data)
      setReportToApproval(data.report)
      //registryLogOld('CUSTOMER Internal Approval', 'inspection-report')
      registryLog('inspection-report', 'api', 'customer_internal_approval')
      setLoading(false)
      resolve()
    }).catch(e => {
      reject(e)
    })

  })

  const approveReport = () => new Promise((resolve, reject) => {
    setLoading(true)

    const type = reportToApproval.next_workflow_status === 'to-tpi-approval' ? 'TPI' : 'customer'
    const status = reportToApproval.next_workflow_status === 'to-tpi-approval' ? 'tpi-approved' : 'customer-approved'

    const report = {
      report_id: reportToApproval.report_id,
      status: status,
      user_id: currentUser.id,
      user_name: currentUser.name,
      user_comment: ''
    }

    inspectionReport.approval(idToken, report).then(data => {
      data = data.body ? data.body : data
      // console.debug(data)
      setReportToApproval(data.report)
      //registryLogOld(type.toUpperCase() + ' Approval', 'inspection-report')
      registryLog('inspection-report', 'api', type.toLowerCase() + '_approval')

      setLoading(false)
      resolve()
    }).catch(e => {
      reject(e)
    })

  })

  const rejectReport = (comment) => new Promise((resolve, reject) => {
    setLoading(true)

    const type = reportToApproval.next_workflow_status === 'to-tpi-approval' ? 'TPI' : 'customer'

    const status = reportToApproval.next_workflow_status === 'to-tpi-approval' ? 'tpi-rejected' : 'customer-rejected'

    const report = {
      report_id: reportToApproval.report_id,
      status: status,
      user_id: currentUser.id,
      user_name: currentUser.name,
      user_comment: comment
    }

    inspectionReport.approval(idToken, report).then(data => {
      data = data.body ? data.body : data
      // console.debug(data)
      setReportToApproval(data.report)
      //registryLogOld(type.toUpperCase() + ' Rejected', 'inspection-report')
      registryLog('inspection-report', 'api', type.toLowerCase() + '_rejected')
      setLoading(false)
      resolve()
    }).catch(e => {
      reject(e)
    })

  })

  const getSignToken = () => new Promise((resolve, reject) => {
    setLoading(true)
    inspectionReport.sign(idToken, { report_id: reportToApproval.report_id, getToken: {} }).then(data => {
      data = data.body ? data.body : data
      // console.debug(data)
      // setReportToApproval(data.report)
      setLoading(false)
      resolve(data.token)
    }).catch(e => {
      reject(e)
    })
  })

  const signReport = (signData) => new Promise((resolve, reject) => {
    const type = reportToApproval.next_workflow_status === 'to-tpi-approval' ? 'TPI' : 'customer'
    setLoading(true)
    inspectionReport.sign(idToken, { report_id: reportToApproval.report_id, completeSign: signData }).then(data => {
      data = data.body ? data.body : data
      // console.debug(data)
      // setReportToApproval(data.report)
      //registryLogOld(type.toUpperCase() + ' signed', 'inspection-report')
      registryLog('inspection-report', 'api', type.toLowerCase() + '_signed')

      const logType = reportToApproval.next_workflow_status === 'to-tpi-approval' ? 'Laudo TPI' : 'Laudo Customer'
      const log = {
        signature: {
          application: 'Gestão de Laudos',
          type: logType,
          documentId: reportToApproval.report_id,
          signer: currentUser.name,
          loggedUser: currentUser.name,
          file: 'inspection_report/' + reportToApproval.report_id
        }
      }
      inspectionReport.logSignature(idToken, log).then()

      setLoading(false)
      resolve(data)
    }).catch(e => {
      reject(e)
    })
  })

  const executeWorkflowStep = (step) => new Promise((resolve, reject) => {
    setLoading(true)
    inspectionReport.workflow(idToken, { report_id: reportToWorkflow.report_id, executeStep: step }).then(data => {
      data = data.body ? data.body : data
      // console.debug(data)
      setReportToWorkflow(data.report)
      //registryLogOld('On Execute Workflow', 'inspection-report')
      registryLog('inspection-report', 'api', 'execute_workflow')
      
      getInspectionReportData(filters, showFinalized, 0)
      .then(() => {})
      .catch((e) => {
        console.debug(e);
      })
      setLoading(false)
      resolve(data)
    }).catch(e => {
      reject(e)
    })
  })

  const getInspectionReportWorkflowData = (report) => new Promise((resolve, reject) => {
    setLoading(true)
    inspectionReport.management(idToken, { get: report }).then(data => {
      data = data.body ? data.body : data
      // console.debug(data)
      setReportToWorkflow(data.report)
      setLoading(false)
      resolve()
    }).catch(e => {
      reject(e)
    })
  })


  const getInspectionReportDocument = (report) => new Promise((resolve, reject) => {
    setLoading(true)
    inspectionReport.management(idToken, { getDocument: report }).then(data => {
      data = data.body ? data.body : data
      setLoading(false)
      resolve(data)
    }).catch(e => {
      reject(e)
    })
  })

  // const filteredinspectionReportData = useMemo(() => {
  //   for (const key of Object.keys(filters)) {
  //     if (filters[key].length === 0) {
  //       delete filters[key]
  //     }
  //   }
  //   const filteredTableData = _.filter(tableData, item => {
  //     let match = true
  //     _.chain(filters)
  //       .pickBy(filter => filter.length > 0)
  //       .each((filter, key) => {
  //         const itemValue = _.get(item, key)
  //         match = match && _.includes(filter, itemValue)
  //       })
  //       .value()
  //     return match
  //   })
  //   return {
  //     ...tableData,
  //     tableData: filteredTableData
  //   }
  // }, [filters, tableData])


  // useEffect(() => {
  //   console.log(filters);
  //   setLoading(true);

  //   getInspectionReportData(showFinalized, 0)
  //   .then(() => {})
  //   .catch((e) => {
  //     console.debug(e);
  //   })
  //   .finally(() => setLoading(false));    


  // }, [filters]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <InspectionReportContext.Provider value={{
      tableData,
      isLoading,
      // filteredinspectionReportData,
      filters,
      setFilters,
      reportToApproval,
      setReportToApproval,
      reportToWorkflow,
      setReportToWorkflow,
      approvalType,
      setApprovalType,
      showFinalized,
      setShowFinalized,
      getInspectionReportData,
      sotList,
      getSotList,
      sotItemList,
      getSotItemList,
      reportIdList,
      getRepostIdList,
      reportVersionList,
      getReportVersionList,
      inspectionDateList,
      getInspectionDateList,
      reportDateList,
      getReportDateList,       
      processStatusList, 
      getProcessStatusList,
      workflowStatusList, 
      getWorkflowStatusList,
      nextWorkflowStatusList, 
      getNextWorkflowStatusList,     
      getInspectionReportApprovalData,
      getInspectionReportWorkflowData,
      getInspectionReportDocument,
      internalApproveReport,
      approveReport,
      rejectReport,
      executeWorkflowStep,
      getSignToken,
      signReport,
      totalData,
      totalPages,
      page
    }}>
      {children}
    </InspectionReportContext.Provider>
  )
}
